import React, { useEffect, useState } from "react";

const mapNotificationDataToDetails = notificationData => ({
    description: notificationData?.description || notificationData?.message || "",
    enableNotification: !!(notificationData?.enableFlag ?? notificationData?.enableNotification),
    notificationId: notificationData?.id || "",
    id: notificationData?.id || null,
});

const NotificationSettings = ({
    UserScope,
    notificationData,
    loading,
    newNotification,
    updateNotification,
    deleteNotification,
}) => {
    const [notificationDetails, setNotificationDetails] = useState(() => ({
        ...mapNotificationDataToDetails(notificationData),
        isEditing: false,
        deleteNotificationConfirmPopUpStatus: false,
    }));

    useEffect(() => {
        const nextData = mapNotificationDataToDetails(notificationData);
        setNotificationDetails(prevState => {
            const isSameData =
                prevState.description === nextData.description &&
                prevState.enableNotification === nextData.enableNotification &&
                prevState.notificationId === nextData.notificationId &&
                prevState.id === nextData.id;

            if (isSameData && !prevState.isEditing && !prevState.deleteNotificationConfirmPopUpStatus) {
                return prevState;
            }

            return {
                ...prevState,
                ...nextData,
                isEditing: false,
                deleteNotificationConfirmPopUpStatus: false,
            };
        });
    }, [notificationData]);

    const handleChangeNotification = e => {
        const { name, value, type, checked } = e.target;
        setNotificationDetails(prevState => ({
            ...prevState,
            [name]: type === "checkbox" ? checked : value,
        }));
    };

    const addNotification = () => {
        setNotificationDetails(prevState => ({
            ...prevState,
            notificationId: "",
            description: "",
            enableNotification: false,
            isEditing: true,
        }));
    };

    const saveNotification = () => {
        const payload = {
                id: notificationDetails.id,
                message: notificationDetails.description,
                createdBy: "",
                createdDate: "",
                updatedBy: "",
                updatedDate: "",
                enableFlag: notificationDetails.enableNotification
        };

        if (notificationDetails.id) {
            updateNotification(payload);
        } else {
            newNotification(payload);
        }

        setNotificationDetails(prevState => ({
            ...prevState,
            isEditing: false,
        }));
    };

    const cancelNotification = () => {
        if (notificationData) {
            setNotificationDetails(prevState => ({
                ...prevState,
                description: notificationData.description || notificationData.message || "",
                enableNotification: !!(notificationData.enableFlag ?? notificationData.enableNotification),
                notificationId: notificationData.id || "",
                isEditing: false,
            }));
            return;
        }

        setNotificationDetails(prevState => ({
            ...prevState,
            notificationId: "",
            description: "",
            enableNotification: false,
            isEditing: false,
        }));
    };

    const editNotification = () => {
        setNotificationDetails(prevState => ({
            ...prevState,
            isEditing: true,
        }));
    };

    const deleteNotificationPopUp = notificationId => {
        setNotificationDetails(prevState => ({
            ...prevState,
            id: notificationId,
            deleteNotificationConfirmPopUpStatus: true,
        }));
    };

    const closeDeleteNotificationPopUp = () => {
        setNotificationDetails(prevState => ({
            ...prevState,
            id: "",
            deleteNotificationConfirmPopUpStatus: false,
        }));
    };

    const removeNotificationConfirm = () => {
        if (notificationDetails.id) {
            deleteNotification(notificationDetails.id);
        }

        setNotificationDetails(prevState => ({
            ...prevState,
            description: "",
            enableNotification: false,
            notificationId: "",
            isEditing: false,
            id: "",
            deleteNotificationConfirmPopUpStatus: false,
        }));
    };

    const hasNotification = (notificationData?.description || notificationData?.message || "") !== "";
    const canSave = UserScope?.access?.saveNews === true;
    return (
        <div className="col-md-12 mt-2 pb-2">
            <div className="row">
                <div className="col-md-12 mt-2">
                    <se-divider></se-divider>
                </div>
            </div>
            <div className="row ">
                <div className="col-md-9 mt-2">
                    <span className="se-life-green se-font-14px-bold ">Notification Settings</span>
                </div>
                <div className="col-md-3 d-flex flex-row-reverse">
                    {canSave && !hasNotification && !notificationDetails.isEditing && (
                        <se-button
                            option="raised"
                            size="small"
                            color="primary"
                            icon="action_add_flat"
                            onClick={addNotification}
                            style={{}}
                        >
                            Add Notification
                        </se-button>
                    )}
                </div>
            </div>

            {(hasNotification || notificationDetails.isEditing) && (
                <div className="row mt-1 pb-2">
                    <div className="col-md-12">
                        <div className="table-responsive">
                            <table className="table table-bordered mb-2">
                                <thead>
                                    <tr>
                                        <th width="70%">Description</th>
                                        <th width="15%">Status</th>
                                        {canSave && <th width="15%" className="text-center">Action</th>}
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>
                                            {notificationDetails.isEditing ? (
                                                <>
                                                    <textarea
                                                        id="notificationDescription"
                                                        className="form-control form-control-md"
                                                        name="description"
                                                        placeholder="Notification Description"
                                                        rows={2}
                                                        value={notificationDetails.description}
                                                        maxLength="300"
                                                        onChange={handleChangeNotification}
                                                    />
                                                    <div
                                                        className="invalid-feedback-custom"
                                                        style={!notificationDetails.description ? {} : { display: "none" }}
                                                    >
                                                        Description is required.
                                                    </div>
                                                </>
                                            ) : (
                                                notificationDetails.description
                                            )}
                                        </td>
                                        <td>
                                            {notificationDetails.isEditing ? (
                                                <div className="custom-control custom-checkbox">
                                                    <input
                                                        type="checkbox"
                                                        className="custom-control-input asCompatible"
                                                        id="Checkbox1"
                                                        name="enableNotification"
                                                        checked={notificationDetails.enableNotification}
                                                        onChange={handleChangeNotification}
                                                    />
                                                    <label
                                                        className="custom-control-label"
                                                        htmlFor="Checkbox1"
                                                    ></label>
                                                </div>
                                            ) : (
                                                notificationDetails.enableNotification ? "Enabled" : "Disabled"
                                            )}
                                        </td>
                                        {canSave && (
                                            <td className="align-middle text-center">
                                                {notificationDetails.isEditing ? (
                                                    <>
                                                        <span className="pointer d-inline-block">
                                                            <se-icon
                                                                size="small"
                                                                color="primary"
                                                                title="Click to Save"
                                                                disabled={notificationDetails.description.trim() === ""}
                                                                onClick={notificationDetails.description.trim() === "" ? undefined : saveNotification}
                                                            >
                                                                notification_ok_stroke
                                                            </se-icon>
                                                        </span>
                                                        <span>&nbsp; &nbsp;</span>
                                                        <span className="pointer d-inline-block">
                                                            <se-icon
                                                                size="small"
                                                                title="Click to cancel"
                                                                onClick={cancelNotification}
                                                            >
                                                                action_delete_cross
                                                            </se-icon>
                                                        </span>
                                                    </>
                                                ) : (
                                                    <>
                                                        <span className="pointer">
                                                            <se-icon
                                                                size="small"
                                                                title="Edit"
                                                                color="primary"
                                                                onClick={editNotification}
                                                            >
                                                                action_editor
                                                            </se-icon>
                                                        </span>
                                                        <span>&nbsp; &nbsp;</span>
                                                        <span className="pointer">
                                                            <se-icon
                                                                size="small"
                                                                title="Delete"
                                                                color="primary"
                                                                onClick={() => deleteNotificationPopUp(notificationDetails.id)}
                                                            >
                                                                action_delete
                                                            </se-icon>
                                                        </span>
                                                    </>
                                                )}
                                            </td>
                                        )}
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            )}

            {!hasNotification && !notificationDetails.isEditing && loading === false && (
                <div className="row mt-1 pb-2">
                    <div className="col-md-12 text-center">No Notification</div>
                </div>
            )}

            <se-dialog
                id="dialog-complex-delete-confirm"
                open={notificationDetails.deleteNotificationConfirmPopUpStatus}
                can-backdrop="false"
            >
                <se-dialog-header>Confirmation</se-dialog-header>
                <se-dialog-content>
                    <span className="se-font-14px">
                        Do you confirm to delete this Notification ?
                    </span>
                </se-dialog-content>
                <se-dialog-footer>
                    <se-button onClick={closeDeleteNotificationPopUp}>Cancel</se-button>
                    <se-button onClick={removeNotificationConfirm}>OK</se-button>
                </se-dialog-footer>
            </se-dialog>
        </div>
    );
};

const arePropsEqual = (prevProps, nextProps) => {
    const prevNotification = prevProps.notificationData || {};
    const nextNotification = nextProps.notificationData || {};

    return (
        prevProps.loading === nextProps.loading &&
        prevProps.UserScope?.access?.saveNews === nextProps.UserScope?.access?.saveNews &&
        (prevNotification.description || prevNotification.message || "") ===
            (nextNotification.description || nextNotification.message || "") &&
        !!(prevNotification.enableFlag ?? prevNotification.enableNotification) ===
            !!(nextNotification.enableFlag ?? nextNotification.enableNotification) &&
        (prevNotification.id || null) === (nextNotification.id || null)
    );
};

export default React.memo(NotificationSettings, arePropsEqual);
